import { render, staticRenderFns } from "./WhatsappErrorNotice.vue?vue&type=template&id=e93d91d4&scoped=true&"
import script from "./WhatsappErrorNotice.vue?vue&type=script&lang=js&"
export * from "./WhatsappErrorNotice.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappErrorNotice.vue?vue&type=style&index=0&id=e93d91d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93d91d4",
  null
  
)

export default component.exports